import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import MuiInput from "@mui/material/Input";
import { FormLabel } from "@mui/material";
import { useProyecto } from "../../data/ProyectoContext";
import { useActividadesContext } from "../UmmIACategories/Hook/useActividades";

const Input = styled(MuiInput)`
  width: 42px;
`;

export default function DuracionSemanas() {
  const { setPromptData } = useActividadesContext();
  const [value, setValue] = React.useState(8);
  const { proyecto, setProyecto } = useProyecto();

  const handleSemanaChange = (nuevaCantidadSemanas: number) => {
    setProyecto({ ...proyecto, cantidad_de_semanas: nuevaCantidadSemanas });
    setPromptData((prevPromptData: any) => ({
      ...prevPromptData,
      cantidad_de_semanas: nuevaCantidadSemanas,
    }));
  };

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number);
    handleSemanaChange(newValue as number);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value === "" ? 1 : Number(event.target.value));
    handleSemanaChange(Number(event.target.value));
  };

  const handleBlur = () => {
    if (value < 1) {
      setValue(1);
    } else if (value > 12) {
      setValue(12);
    }
  };

  return (
    <Box sx={{ width: "90%", ml: 4 }}>
      <Box sx={{ display: "flex", flexDirection: "column", pb: 1 }}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "1.25rem",
            color: "#336B87",
            fontWeight: "bold",
          }}
        >
          Cantidad de semanas *
        </Typography>
        <FormLabel
          component="p"
          sx={{ fontFamily: "Montserrat", fontSize: "0.85rem", mt: 0.2 }}
        >
          Selecciona el total de semanas que debe cubrir esta planificación.
        </FormLabel>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs>
          <Slider
            value={typeof value === "number" ? value : 0}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            color="success"
            sx={{
              ml: 2,
              width: "95%",
              color: "#336B87",
              "& .MuiSlider-markLabel": {
                color: "#336B87",
                fontFamily: "montserrat",
              },
              "& .MuiSlider-valueLabel": {
                backgroundColor: "#F9DA96",
                color: "#209099",
                fontFamily: "montserrat",
              },
            }}
            valueLabelDisplay="auto"
            defaultValue={8}
            min={1}
            max={12}
          />
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="body2"
              sx={{
                cursor: "pointer",
                fontSize: "0.62rem",
                color: "rgba(0, 0, 0, 0.6)",
              }}
            >
              1 semana
            </Typography>
            <Typography
              variant="body2"
              sx={{
                cursor: "pointer",
                fontSize: "0.62rem",
                color: "rgba(0, 0, 0, 0.6)",
              }}
            >
              12 semanas
            </Typography>
          </Box>
        </Grid>
        <Grid item mt={2}>
          <Input
            value={value}
            size="small"
            onChange={handleInputChange}
            onBlur={handleBlur}
            inputProps={{
              step: 1,
              min: 1,
              max: 12,
              type: "number",
              "aria-labelledby": "input-slider",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
